<div
  class="d-flex responsiveMedia"
  *ngIf="
    (authRepo.isUser$ | async) || (authRepo.isTenantAdmin$ | async);
    else elseBlock
  "
>
  <div class="page d-flex flex-column flex-grow-1" style="overflow-y: scroll">
    <app-logo class="d-flex mb-2" [forHomePage]="true"></app-logo>
    <div
      [innerHtml]="homeTenantModel.descriptionMobile"
      class="d-block d-md-none text-muted text-mobile-center"
    ></div>
    <div class="flex-grow-1">
      <div *ngIf="menuItems" class="row m-0 p-0">
        <app-menu-item
          *ngFor="let item of menuItems"
          class="d-flex justify-content-center col-6 col-sm-4 m-0 p-3"
          style="aspect-ratio: 1"
          [item]="item"
          (subMenuOpen)="openSubMenu($event, item.name)"
          [iconColor]="tenantPrimaryColor!"
        ></app-menu-item>
      </div>
    </div>
  </div>
</div>
<div class="showOnBigScreen">
  <div class="row justify-content-center">
    <div class="row col-12 col-lg-11 col-xl-10 max-900 pb-3 pt-sm-3 ps-0 pe-0">
      <div *ngIf="tenantHasNoInfo(); else elseBlock">
        <h2 class="sm-del page-title col-sm-4 col-12">
          {{ "home" | transloco }}
        </h2>

        <div class="useTheMenu">{{ "useMenu" | transloco }}</div>
      </div>
      <ng-template #elseBlock>
        <div>
          <h1 class="mb-4 mt-4">{{ homeTenantModel.headline }}</h1>

          <div [innerHtml]="homeTenantModel.pageHtml"></div>
          <div class="w-100 d-flex flex-column align-items-center">
            <img
              *ngIf="homeTenantModel.logo"
              class="img my-3"
              [src]="imageSafe"
            />

            <div class="col-lg-9 col-12" *ngIf="homeTenantModel.videoUrl">
              <iframe
                frameBorder="0"
                [src]="videpUrlSafe"
                class="mainVideo"
                allowscriptaccess="always"
              ></iframe>
            </div>
          </div>
          <!-- <div [innerHtml]="description"></div> -->
          <div
            class="d-none d-md-block"
            [innerHtml]="homeTenantModel.pageHtml2"
          ></div>
          <!-- <div
            class="d-block d-md-none"
            [innerHtml]="homeTenantModel.descriptionMobile"
          ></div> -->
        </div>
      </ng-template>
    </div>
  </div>
</div>
<ng-template #elseBlock>
  <!--head administrator-->
</ng-template>
